// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class NewOrderMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_NEW_ORDER_MESSAGE, fieldSet);
    }
    setOnBehalfId(onBehalfId) {
        this.setFieldValue(FieldsFactory.FIELD_ON_BEHALF_USER_ID, onBehalfId);
    }
    setPlacedFrom(placedFrom) {
        this.setFieldValue(FieldsFactory.FIELD_CLIENT_PANEL, placedFrom);
    }
}
